import { requestGet, requestFormPost } from '@/common/request';
export default {
  async getMyTodoList(query) {
    return await requestGet('/home/myBacklog', query);
  },
  async getDataPanel(query) {
    return await requestGet('/home/dataPanel', query);
  },
  async getVenueProcess(query) {
    return await requestGet('/home/venueProgress', query);
  },
  async getUserInfo(query) {
    return await requestGet('/user/guide', query);
  },
  // 查询项目列表
  async HelpListCategory(query) {
    return await requestGet('/help/listCategory', query);
  },
  async resetNewguideWithActivityMange() {
    // homeNewUser actManageList actManageDetail
    return await Promise.all([
      requestGet('/user/resetGuide', { key: 'actManageList' }),
      requestGet('/user/resetGuide', { key: 'actManageDetail' }),
    ]);
  },
  // 查询banner列表
  async bannerList(query) {
    return await requestGet('/banner/list', query);
  },
  // 新的查询banner列表
  async newBannerList(query) {
    return await requestGet('/generic/mac/activity/banner', query);
  },
  // 首页-获取招商活动下拉数据
  async homeBizActivities(query) {
    return await requestGet('/home/bizActivities', query);
  },
  // 首页-获取招商活动摘要
  async homeActivitySummary(query) {
    return await requestGet('/home/activitySummary', query);
  },
  // 我的收藏
  async homeData(query) {
    return await requestGet('/home/myData', query);
  },
  // 微频道状态数据
  async channelMicroStatusCount(query) {
    return await requestGet('/channelMicro/statusCount', query);
  },
  async HelpListHomePageCategory(query) {
    return await requestGet('/help/listHomePageCategory', query);
  },
  async HelpGetDocument(query) {
    return await requestGet('/help/getDocument', query);
  },
  async HelpEvaluation(query) {
    return await requestGet('/help/evaluation', query);
  },

  async HelpUseful(query) {
    return await requestGet('/help/useful', query);
  },
  async getRecommendActivityMenu(query) {
    return await requestGet('/recommend/query/menu', query);
  },
};
// E112-首页推荐活动-大促日历配置
// https://cf.jd.com/pages/viewpage.action?pageId=1393151824
export const getCalender = async (query) => {
  return await requestFormPost(`/recommend/calender/list`, query);
};

// E114-首页推荐活动-自定义配置
// https://cf.jd.com/pages/viewpage.action?pageId=1393151830
export const getRecommendActivityList = async (query) => {
  return await requestGet('/recommend/query/activityList', query);
};

// E113-首页推荐活动-百补配置
// https://cf.jd.com/pages/viewpage.action?pageId=1393151827
export const getRecommendBiddingList = async (query) => {
  return await requestGet('/recommend/query/biddingList', query);
};
